const US_STATE_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'DC',
]

const CANADIAN_PROVINCE_CODES = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NS',
  'NT',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
]

const REGION_NAME_TO_CODE: Partial<Record<string, string>> = {
  alabama: 'AL',
  alaska: 'AK',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  florida: 'FL',
  georgia: 'GA',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  'west virginia': 'WV',
  wisconsin: 'WI',
  wyoming: 'WY',
  'district of columbia': 'DC',
  alberta: 'AB',
  'british columbia': 'BC',
  manitoba: 'MB',
  'new brunswick': 'NB',
  'newfoundland and labrador': 'NL',
  'nova scotia': 'NS',
  'northwest territories': 'NT',
  nunavut: 'NU',
  ontario: 'ON',
  'prince edward island': 'PE',
  quebec: 'QC',
  saskatchewan: 'SK',
  yukon: 'YT',
}

const ADDRESS_REGION_CODES = [...US_STATE_CODES, ...CANADIAN_PROVINCE_CODES]

export const ADDRESS_REGION_OPTIONS = ADDRESS_REGION_CODES.map((code) => ({
  id: code,
  name: code,
}))

export function normalizeAddressRegionCode(value: unknown): string {
  // oxlint-disable-next-line typescript/no-base-to-string -- preserve legacy coercion of freeform address values
  const trimmed = String(value ?? '').trim()

  if (!trimmed) {
    return ''
  }

  const uppercase = trimmed.toUpperCase()
  if (ADDRESS_REGION_CODES.includes(uppercase)) {
    return uppercase
  }

  return REGION_NAME_TO_CODE[trimmed.toLowerCase()] ?? trimmed
}

export function getAddressRegionOptions(currentValue: unknown): { id: string; name: string }[] {
  // oxlint-disable-next-line typescript/no-base-to-string -- preserve legacy coercion of freeform address values
  const trimmed = String(currentValue ?? '').trim()

  if (!trimmed || ADDRESS_REGION_OPTIONS.some((option) => option.id === trimmed)) {
    return ADDRESS_REGION_OPTIONS
  }

  return [{ id: trimmed, name: trimmed }, ...ADDRESS_REGION_OPTIONS]
}
